import { Link } from "react-router-dom";
import type { Video } from "@/types/video";
import { formatViews, getTypeName } from "@/utils/video";

interface VideoCardProps {
  video: Video;
  rank?: number;
}

export default function VideoCard({ video, rank }: VideoCardProps) {
  return (
    <Link
      to={`/detail/${video.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-accent-300"
    >
      <div className="relative w-full aspect-video overflow-hidden bg-background-100">
        <img
          src={video.cover}
          alt={`${video.title}封面`}
          title={`${video.title} - 污视频影视资源`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-md bg-primary-500/90 px-2 py-0.5 text-xs font-medium text-background-50">
          {getTypeName(video.type)}
        </span>
        <span className="absolute right-2 top-2 flex items-center gap-1 rounded-md bg-accent-500 px-2 py-0.5 text-xs font-semibold text-background-50">
          <i className="ri-star-fill text-xs"></i>
          {video.rating.toFixed(1)}
        </span>
        {typeof rank === "number" && (
          <span className="absolute bottom-2 left-2 flex h-7 w-7 items-center justify-center rounded-md bg-background-50/95 font-heading text-sm font-bold text-accent-600">
            {rank}
          </span>
        )}
        <span className="absolute inset-0 flex items-center justify-center bg-primary-950/0 opacity-0 transition-all duration-300 group-hover:bg-primary-950/40 group-hover:opacity-100">
          <i className="ri-play-circle-line text-4xl text-background-50"></i>
        </span>
      </div>
      <div className="flex flex-1 flex-col gap-2 p-3 md:p-4">
        <h3 className="line-clamp-1 font-heading text-sm font-semibold text-foreground-950 transition-colors group-hover:text-accent-600 md:text-base">
          {video.title}
        </h3>
        <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-foreground-500">
          <span>{video.region}</span>
          <span>{video.year}</span>
          <span className="flex items-center gap-1">
            <i className="ri-fire-line"></i>
            {formatViews(video.views)}
          </span>
        </div>
        <div className="mt-auto flex items-center justify-between border-t border-background-100 pt-2 text-xs text-foreground-400">
          <span>更新 {video.updateDate}</span>
          <span className="truncate">{video.tags[0]}</span>
        </div>
      </div>
    </Link>
  );
}